// extracted by css-extract-rspack-plugin
export default {"spinner":"spinner-x0_sys","load8":"load8-aL7Fy6"};